module.exports = __webpack_public_path__ + "static/media/Pastel de naranja.cacb3b23.jpg";